import { Component, Input, OnInit } from "@angular/core";

import { Row } from "@/shared-module/models";
import { ZoneItem } from "../zone/zone-item";

@Component({
  selector: "app-zonepanel",
  templateUrl: "zonepanel.component.html",
})
export class ZonePanelComponent implements OnInit {
  newRows: Row[] = [];

  @Input("zones")
  set rows(value: ZoneItem[]) {
    this.newRows = [];
    let currentRow: Row = { zones: ZoneItem[0] };
    currentRow.zones = [];
    let currentRowUsedSpace = 0;

    this.newRows.push(currentRow);

    value.forEach((itm: ZoneItem) => {
      const width = itm.width;

      if (currentRowUsedSpace + width <= 12) {
        if (currentRowUsedSpace !== 0) {
          itm.needpaddingLeft = true;
        }
        currentRow.zones.push(itm);
        currentRowUsedSpace += width;
      } else {
        // new row
        currentRow = { zones: ZoneItem[0] };
        currentRow.zones = [];
        currentRowUsedSpace = 0;
        this.newRows.push(currentRow);

        currentRow.zones.push(itm);
        currentRowUsedSpace = width;
      }
    });
  }

  ngOnInit() {}
}
